import { render, staticRenderFns } from "./FundSizeDetailsNetWorth.vue?vue&type=template&id=32f6e6a4&scoped=true"
import script from "./FundSizeDetailsNetWorth.vue?vue&type=script&lang=js"
export * from "./FundSizeDetailsNetWorth.vue?vue&type=script&lang=js"
import style0 from "./FundSizeDetailsNetWorth.vue?vue&type=style&index=0&id=32f6e6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6e6a4",
  null
  
)

export default component.exports